// extracted by mini-css-extract-plugin
export default {"root":"StoreRevenue_root__7GnED","heading":"StoreRevenue_heading__nGjPq"};